/**
 * Modal de técnicos vinculados ao território (técnico máquina tipo território).
 */

import React from 'react';
import { LandPlot } from 'lucide-react';
import { OrderDetailsV2MenuModal } from './OrderDetailsV2MenuModal';

export function OrderDetailsTecnicosTerritorioModal({
  open,
  onClose,
  orderId,
  tecnicos,
  loading,
  error,
}) {
  return (
    <OrderDetailsV2MenuModal
      open={open}
      onClose={onClose}
      title="Técnicos do território"
      icon={<LandPlot size={18} strokeWidth={2} aria-hidden />}
      orderId={orderId}
      titleId="odv2-territorio-modal-title"
      closeAriaLabel="Fechar técnicos do território"
      bodyClassName="odv2-menu-modal-body--territorio"
    >
      {loading ? (
        <p className="order-details-v2-territorio-modal-hint">Carregando técnicos…</p>
      ) : null}
      {error ? (
        <p className="order-details-v2-territorio-modal-error" role="alert">
          {error}
        </p>
      ) : null}
      {!loading && !error && tecnicos ? (
        <ul className="order-details-v2-territorio-modal-list">
          {(tecnicos.length ? tecnicos : ['Nenhum técnico encontrado']).map((nome, index) => (
            <li key={`${nome}-${index}`}>{nome}</li>
          ))}
        </ul>
      ) : null}
    </OrderDetailsV2MenuModal>
  );
}
